<template>
	<module class="module-config" :drag="false" gap="10">
		<module-row v-for="(item, i) in dataList" :key="i" size="auto" :title="`指标${i + 1}`">
			<template #head>
				<div class="flex-end-center">
					<c-tooltip class="quota-signal" color="white" align="end">
						<p>指标位置示意</p>
						<template #tip>
							<signal :index="i + 1"></signal>
						</template>
					</c-tooltip>
				</div>
			</template>
			<c-form ref="form" column="2" vertical unit-width="100%">
				<c-form-item label="指标名称" required>
					<c-input v-model="item.name" name="name"></c-input>
				</c-form-item>
				<c-form-item label="数据源" required>
					<c-select v-model="item.source" name="source" :options="quotaDataSource" :clear="false" @change="sourceHandle(item, i)"></c-select>
				</c-form-item>
				<div class="flex" style="width: calc(50% - 10px); gap: 10px">
					<c-form-item class="flex-grow" label="指标项" required style="width: 0;">
						<c-select v-model="item.quota" name="quota" :options="item.quotaOptions" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="计算方式" style="width: 120px;">
						<c-select v-model="item.computed" :options="quotaComputedOptions[quotaDataType[i]]" :clear="false"></c-select>
					</c-form-item>
				</div>
				<c-form-item label="颜色" required>
					<ul class="color-list flex-center-cross">
						<li v-for="(color, j) in colorList" :key="j" class="flex-center" :class="{'z-crt': item.color == color}" @click="item.color = color">
							<div :style="{'background': `var(--color-${color})`}"></div>
						</li>
					</ul>
				</c-form-item>
				<c-form-item label="数据过滤">
					<data-filter ref="dataFilter"></data-filter>
				</c-form-item>
			</c-form>
		</module-row>
	</module>
</template>

<script>
	import signal from './config_quota_signal.vue'
	import dataFilter from '@/components/view/data_filter.vue'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		components: {
			signal,
			dataFilter
		},

		data() {
			return {
				...getStore(this),
				dataList: new Array(10).fill('').map(() => {
					return {
						name: '',
						source: '',
						quotaOptions: [],
						quota: '',
						computed: '',
						color: 'white'
					};
				}),
				colorList: ['white', 'green', 'red', 'yellow']
			}
		},

		computed: {
			...mapStore(['quotaDataSource', 'quotaComputedOptions']),

			quotaDataType() {
				return this.dataList.map(item => {
					let field = item.quotaOptions.find(field => field.value == item.quota);
					return field ? field.type : 0;
				});
			}
		},
		
		watch: {
			quotaDataSource() {
				this.init();
			}
		},

		mounted() {
			this.store.getDataSource('quota');
		},

		methods: {
			init() {
				this.quotaDataSource.length && this.dataList.forEach((item, index) => {
					if (!item.source) {
						item.source = this.quotaDataSource[0].value;
					}
					if (!item.quotaOptions.length) {
						this.getQuota(item, index);
					}
					this.$refs.dataFilter[index].set(item.source, item.filter || []);
				});
			},

			sourceHandle(item, index) {
				this.$refs.dataFilter[index].set(item.source, []);
				this.updateOptions(item);
			},

			updateOptions(item) {
				this.getQuota(item);
			},

			getQuota(item, index = 0) {
				this.store.getQuota(2, 5, item.source, data => {
					item.quotaOptions = data;
					this.$nextTick(() => {
						if (!item.quota) {
							item.quota = data[index].value;
						}
					})
				});
			},

			setConfig(config = {}) {
				if (config.data) {
					config.data.forEach((item, index) => {
						this.dataList[index] = Object.assign(this.dataList[index], item);
					});
				}
				this.dataList.forEach((item, index) => {
					this.$watch(() => item.source, () => {
						let oldData = item.quotaOptions.find(opt => opt.value == item.quota);
						if (!item.name.trim() || (oldData && item.name.trim() == oldData.name)) {
							item.name = '';
						}
					});

					this.$watch(() => item.quota, (val, old) => {
						let valData = item.quotaOptions.find(opt => opt.value == val);
						if (!valData) return;
						let oldData = item.quotaOptions.find(opt => opt.value == old);
						if (!item.name.trim() || (oldData && item.name.trim() == oldData.name)) {
							item.name = valData.name;
						}
					});

					this.$watch(() => item.computed, (val, old) => {
						if (!val) {
							this.$nextTick(() => {
								let oldOpt = this.quotaComputedOptions[this.quotaDataType[index]].find(item => item.value == old);
								item.computed = (oldOpt || this.quotaComputedOptions[this.quotaDataType[index]][0]).value;
							});
						}
					}, {
						immediate: true
					});
				});
				this.init();
			},

			getConfig() {
				return new Promise(resolve => {
					Promise.all(this.$refs.form.map($form => {
						return new Promise(resolve => {
							$form.validate({
								rule: {
									name: '请填写指标名称',
									source: '请选择数据源',
									quota: '请选择指标项'
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					})).then(data => {
						if (data.findIndex(item => item === false) == -1) {
							resolve({
								type: 2,
								data: this.dataList.map((item, index) => {
									item.filter = this.$refs.dataFilter[index].get();
									return item;
								})
							});
						} else {
							resolve(false);
						}
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.quota-signal {
		margin-right: 20px;
		margin-top: 16px;

		p {
			font-size: 13px;
		}
	}

	.color-list {
		gap: 8px;
		padding: 2px 0;

		li {
			box-sizing: border-box;
			width: 34px;
			height: 34px;
			border: 1px solid #fff;
			border-radius: 100%;
			cursor: pointer;

			&:hover,
			&.z-crt {
				border-color: var(--color-main);
			}

			div {
				width: 22px;
				height: 22px;
				border: 1px solid #ddd;
				border-radius: 100%;
			}
		}
	}
</style>